import React from 'react';
import { SlColumn, SlRow } from '@stackline/ui';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';

interface UnitsSoldPreviewProps {
  metric: string;
}

const UnitsSoldPreview = ({ metric }: UnitsSoldPreviewProps) => {
  return (
    <SlColumn spacing="xs">
      <Text transform="uppercase" variant="subtitle4" color="secondary">
        Units Sold Change
      </Text>
      <SlRow spacing="sm" verticalPosition="center">
        <Text variant="body0">{metric}</Text>
      </SlRow>
    </SlColumn>
  );
};

export default UnitsSoldPreview;
